import { MotionValue, useTransform } from "motion/react";
import { ANIMATION_CONFIG } from "../../constants/animations";
import { AnimationConfig, ResponsiveAnimations } from "../../types/animations";

export const useResponsiveAnimations = (
  scrollYProgress: MotionValue<number>,
  viewportWidth: number,
  config: AnimationConfig
): ResponsiveAnimations => {
  const getResponsiveValue = (
    baseValue: number,
    isVertical: boolean = false
  ) => {
    const scale = Math.min(viewportWidth / 1440, 1);

    // Apply additional scaling for 3xl screens (assumed to be 1920px and above)
    if (viewportWidth >= 1920) {
      const threexlScale = 1.5; // Increase dispersion by 50% for 3xl screens
      return baseValue * threexlScale;
    }

    // Apply additional vertical scaling for screens between sm (640px) and md (768px)
    if (isVertical && viewportWidth >= 640 && viewportWidth < 768) {
      const verticalScale = 1.4; // Increase vertical dispersion by 40%
      return baseValue * scale * verticalScale;
    }

    return baseValue * scale;
  };

  return {
    x: useTransform(scrollYProgress, ANIMATION_CONFIG.scrollRange, [
      config.baseX[0],
      getResponsiveValue(config.baseX[1]),
    ]),
    y: useTransform(scrollYProgress, ANIMATION_CONFIG.scrollRange, [
      config.baseY[0],
      getResponsiveValue(config.baseY[1], true),
    ]),
    rotate: useTransform(
      scrollYProgress,
      ANIMATION_CONFIG.scrollRange,
      config.rotation
    ),
  };
};
